import axios from 'axios';
import CommonService from '../../../services/commonService';
import {
  PAGES_API_CALL_BEGIN,
  PAGES_API_CALL_SUCCESS,
  PAGES_API_CALL_FAILURE,
  PAGES_API_CALL_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function apiCall(args = {}) {
  console.log('inside api callllllll----------', args);
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PAGES_API_CALL_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let doRequest;

      if (args.method === 'PUT') {
        doRequest = axios.put(args.url, args.data, {
          headers: args.type == 'home' ? CommonService.getHeaders() : CommonService.getAtHeaders(),
        });
      } else if (args.method === 'POST') {
        doRequest = axios.post(args.url, args.data, {
          headers: args.type == 'home' ? CommonService.getHeaders() : CommonService.getAtHeaders(),
        });
      } else if (args.method === 'DELETE') {
        doRequest = axios.delete(args.url, {
          headers: args.type == 'home' ? CommonService.getHeaders() : CommonService.getAtHeaders(),
        });
      } else {
        doRequest = axios.get(args.url, {
          headers: args.type == 'home' ? CommonService.getHeaders() : CommonService.getAtHeaders(),
        });
        // console.log('Headers', CommonService.getAtHeaders());
      }

      doRequest.then(
        res => {
          dispatch({
            type: PAGES_API_CALL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: PAGES_API_CALL_FAILURE,
            data: { error: err },
          });
          if (err.response && err.response.status === 401) {
            CommonService.logout();
            window.location.href = '/';
          }
          reject(err.response);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissApiCallError() {
  return {
    type: PAGES_API_CALL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PAGES_API_CALL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        apiCallPending: true,
        apiCallError: null,
      };

    case PAGES_API_CALL_SUCCESS:
      // The request is success
      return {
        ...state,
        apiCallPending: false,
        apiCallError: null,
      };

    case PAGES_API_CALL_FAILURE:
      // The request is failed
      return {
        ...state,
        apiCallPending: false,
        apiCallError: action.data.error,
      };

    case PAGES_API_CALL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        apiCallError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/pages/redux/apiCall.js